import React from 'react'
import { Grid, Rating } from '@mui/material';
import { withStyles } from '@mui/styles';

const StyledRating = withStyles({
  iconFilled: {
    color: '#0F265C',
  }

})(Rating)

const Comments: React.FC = () => {
  return (
    <div >
      <Grid container className="bp-mt-64" >
        <Grid item xs={12}>
          <pichincha-typography variant="h2" align="center" color='darkGrey' weight_color='500' >
            ¿Qué dicen nuestros clientes?
          </pichincha-typography>
          <pichincha-typography variant="h5" class='bp-mt-8' align="center" color='darkGrey' weight_color='500'>
            Nuestos usuarios califican nuestro flujo digital con <strong>4,5/5.</strong>
          </pichincha-typography>
          <Grid container justifyContent='center' className='bp-mt-32'>
            <StyledRating name="half-rating-read" defaultValue={4.5} color="secondary" precision={0.5} readOnly />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default Comments
